import { Action } from '@ngrx/store';
import { TeamMember } from '../_models/team-member.model';
import { QueryParamsModel } from '../../_base/crud';

export enum TeamMemberActionTypes {
  TeamMembersPageRequested = '[TeamMembers] TeamMembers Page Requested',
  TeamMembersPageLoaded = '[TeamMembers] TeamMembers Page Loaded',
  TeamMembersPageCancelled = '[TeamMembers] TeamMembers Page Cancelled',
  ThrowTeamMemberError = '[TeamMembers] Throw Error',
  FireTeamMemberSuccess = '[TeamMembers] Fire Success',
  TeamMembersPageToggleLoading = '[TeamMembers] TeamMembers Page Toggle Loading',
  ClearMemberState = '[TeamMembers] Clear Member State',
}

export class ThrowTeamMemberError implements Action {
  readonly type = TeamMemberActionTypes.ThrowTeamMemberError;

  constructor(public payload: { error: any }) {}
}

export class FireTeamMemberSuccess implements Action {
  readonly type = TeamMemberActionTypes.FireTeamMemberSuccess;

  constructor(public payload: { action_type: string }) {}
}

export class TeamMembersPageRequested implements Action {
  readonly type = TeamMemberActionTypes.TeamMembersPageRequested;

  constructor(public payload: { page: QueryParamsModel; category_id: any; category_name: any }) {}
}

export class TeamMembersPageLoaded implements Action {
  readonly type = TeamMemberActionTypes.TeamMembersPageLoaded;

  constructor(
    public payload: { teamMembers: TeamMember[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class TeamMembersPageCancelled implements Action {
  readonly type = TeamMemberActionTypes.TeamMembersPageCancelled;
}

export class TeamMembersPageToggleLoading implements Action {
  readonly type = TeamMemberActionTypes.TeamMembersPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}
export class ClearMemberState implements Action {
  readonly type = TeamMemberActionTypes.ClearMemberState;
}
export type TeamMemberActions =
  | TeamMembersPageRequested
  | TeamMembersPageLoaded
  | TeamMembersPageCancelled
  | TeamMembersPageToggleLoading
  | ThrowTeamMemberError
  | FireTeamMemberSuccess
  | ClearMemberState;
